<template>
  <div ref="layout_main_box" :class="['app-wrapper',hideScrollBar?'main_app_box':'']">
    <!-- <TopMsg/> -->
    <Search/>
    <Tabbar/>
    <AppMain/>
    <BtmMsg v-if="showBtm"/>
  </div>
</template>

<script>
import {AppMain, TopMsg, Search, Tabbar, BtmMsg} from "./comps";
export default {
  components: {
    AppMain,
    TopMsg,
    Search,
    Tabbar,
    BtmMsg,
  },
  data() {
    return {
      hideScrollBar: true,
      showBtm: true
    }
  },
  mounted() {
    this.$nextTick(()=>{
      if (this.$refs.layout_main_box && window.devicePixelRatio>1 && window.innerWidth<1400) {
        const a = (1400-window.innerWidth)/2
        this.$refs.layout_main_box.scrollLeft = a
        window.scrollTo(a, 0)
      }
      this.hideScrollBar = false
    })

  },
  watch: {
    $route: {
      handler(to, from) {
        this.hideScrollBar = true;
        this.$nextTick(() => {
          this.hideScrollBar = false;
        });
        this.showBtm = to.path !== '/pre'
      },
      immediate: true,
    },
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100vh;
  width: 100%;
  min-width: 1400px;
  font-size: 14px;
  overflow-y: scroll;
}
.main_app_box::-webkit-scrollbar {
  display: none !important;
}
</style>
